<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s" id="deleteListTitle">{{ computedProps.clearCart ? 'Clear cart' : computedProps.type == "item" ? `Delete List Item` : `Delete List` }}</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column" id="deleteListBody">
                
                <div class="modal__body--content-wrapper">
                    <p v-if="!computedProps.clearCart">Are you sure you want to delete this List {{ computedProps.type == "item" ? `Item` : `` }}?</p>
                    <p v-else>Are you sure you want to clear your cart?</p>
                </div>
                <div class="flex-row-forced justify-around">
                    <RothcoCta type="button" class="secondary" @click="closeDialog()">
                        Cancel
                    </RothcoCta>
                    <RothcoCta type="button" class="primary" id="submitButton" @click="submit">
                        {{ computedProps.clearCart ? `Clear` : `Delete` }}
                    </RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import { router } from "@inertiajs/vue3";
    import { useLists } from "@/helpers/composables/useList";
    import RothcoCta from "@/components/RothcoCta.vue"
    import { useSearchSpringCookiesStore } from "@/store/searchSpringCookies";
    import CloseIcon from "@icons/closeIcon.svg";
    let route = inject('route');
    let { deleteList, deleteListRow } = useLists({ router, route });
    let modelValue = defineModel();
    let props = defineProps({
        type: {
            type: String,
            default: "list"
        },
        list_id: {
            type: Number,
            default: null
        },
        list_item_id: {
            type: Number,
            default: null
        },
        after_delete: {
            type: String
        },
        beforeCloseForItem: {
            type: Function,
            default: null
        },
        beforeCloseForList: {
            type: Function,
            default: null
        }
    });
    const dialogRef = inject("dialogRef");

    const isPrimeVueDialog = computed(() => {
        return dialogRef?.value;
    });
    const computedProps = computed(() => {
        return (
            dialogRef?.value?.data ?? {
                type: props.type,
                list_id: props.list_id,
                list_item_id: props.list_item_id,
                after_delete: props.after_delete,
                beforeCloseForItem: props.beforeCloseForItem,
                beforeCloseForList: props.beforeCloseForList,
                clearCart: false,
                itemNumber: props.itemNumber
            }
        );
    });

    const closeDialog = function () {
        if (dialogRef.value) {
            dialogRef.value?.close?.({cancelled: true});
        } else {
            modelValue.value = false;
        }
    };

    let { clearCartProduct } = useSearchSpringCookiesStore();
    const submit = function () {
        if (computedProps.value.type == "item") {
            deleteListRow(computedProps.value.list_item_id, {

                afterFetch: () => {
                    clearCartProduct(computedProps.value.itemNumber);
                    computedProps.value.beforeCloseForItem(
                        computedProps.value.list_item_id
                    );
                    closeDialog();
                }
            });
        } else if (computedProps.value.type) {
            deleteList(computedProps.value.list_id, {
                afterFetch: () => {
                    computedProps.value.beforeCloseForList(
                        computedProps.value.list_id
                    );
                    closeDialog();
                }
            });
        }
    };
</script>
